<template>
    <div>
        <div v-html="text">
        </div>

    </div>

</template>

<script>
import _ from 'lodash';
import database_services from "../../services/database.js";

    export default {
        props: {
            format: {
                default: "small"
            },
            init_params: {
            }
        },
        data: function () {
            return {
                text: "",
                data: null
            };
		},
		methods: {
            async load(data)
            {
                this.data = data;

                console.log(data);

                // Préparer le texte de base
                let textTemplate = "";
                if (this.format == 'small')
                    textTemplate = this.data.text_small ? this.data.text_small : "";
                else
                    textTemplate = this.data.text_big ? this.data.text_big : "";

                if (this.data.return_line)
                    textTemplate = textTemplate.replace(/\n/g, "<br />");

                // Charger les données des requêtes
                let templateData = {
                    db: {}
                };
                
                if (this.data.queries && this.data.queries.length > 0) {
                    for (let query of this.data.queries) {
                        if (query.config && query.name) {
                            try {
                                // Construire la requête à partir de la config
                                let select = query.config.select || "*";
                                let table = query.config.table || query.table;
                                let where = query.config.rules_sql || "";
                                let event = query.config.event || "";
                                
                                // Construire le paramètre "end" qui contient WHERE + ORDER BY + LIMIT etc.
                                let end = "";
                                if (where) {
                                    end += ` ${where}`;
                                }
                                if (event) {
                                    end += ` ${event}`;
                                }
                                
                                // Récupérer la structure de la table pour identifier les colonnes JSON
                                let columns = await database_services.get("show", table);
                                let jsonColumns = new Set();
                                if (columns && Array.isArray(columns)) {
                                    columns.forEach(col => {
                                        if (col.Type && (col.Type.toLowerCase().includes('json') || col.Type.toLowerCase().includes('jsonb'))) {
                                            jsonColumns.add(col.Field);
                                        }
                                    });
                                }
                                
                                // Exécuter la requête comme database.vue le fait
                                let result = await database_services.get("select", table, {
                                    select: select,
                                    end: end.trim()
                                });
                                
                                // Parser uniquement les colonnes JSON identifiées
                                if (result && Array.isArray(result) && jsonColumns.size > 0) {
                                    result = result.map(row => {
                                        const parsedRow = { ...row };
                                        for (let key of jsonColumns) {
                                            if (parsedRow[key] && typeof parsedRow[key] === 'string') {
                                                try {
                                                    parsedRow[key] = JSON.parse(parsedRow[key]);
                                                } catch (e) {
                                                    // Garder la valeur originale si le parsing échoue
                                                }
                                            }
                                        }
                                        return parsedRow;
                                    });
                                }
                                
                                // Rendre les données disponibles dans l'objet db avec le nom de la requête
                                templateData.db[query.name] = result || [];
                            } catch (error) {
                                console.error("Erreur lors du chargement de la requête " + query.name, error);
                                templateData.db[query.name] = [];
                            }
                        }
                    }
                }

                // Compiler le template avec les données
                try {
                    var compiled = _.template(textTemplate);
                    this.text = compiled(templateData);
                } catch (error) {
                    console.error("Erreur lors de la compilation du template", error);
                    this.text = textTemplate;
                }
            }
		},
		mounted: function () {
            if (this.init_params)
                this.load(this.init_params);
		},
    }


</script>